import { useEffect, useState } from 'react';
import AuthenticatedLayout from '../layouts/AuthenticatedLayout';
import AddKategorije from "./Kategorije/Add";
import SecondaryButton from "../components/SecondaryButton";
import Swal from "sweetalert2";
import {useNavigate} from "react-router-dom";

export default function Kategorije() {
    const navigate = useNavigate()
    const [user, setUser] = useState(null);
    const [kategorije, setKategorije] = useState([]);
    const [loading, setLoading] = useState(true);
    const [action, setAction] = useState('list');
    const [category, setCategory] = useState()

    useEffect(() => {
        const userData = localStorage.getItem('wp_user');
        if (userData) {
            setUser(JSON.parse(userData));
        }

        fetchKategorije();
    }, []);

    const fetchKategorije = async () => {
        const token = localStorage.getItem('wp_jwt');
        if (!token) return;
        const apiUrl = process.env.REACT_APP_WORDPRESS_URL;
        const res = await fetch(`${apiUrl}/wp-json/biznis/v1/kategorije`,{
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        const data = await res.json();
        if (data?.data?.status==403) {
            localStorage.removeItem('wp_jwt');
            localStorage.removeItem('wp_user');
            Swal.fire({
                html: 'Session Expired',
                icon: 'error',
                showConfirmButton: false,
                timer: 3000,
                position: "bottom-end",
            });
            setTimeout(()=> {
                navigate('/login');
            },2000)
            return

        }
        setKategorije(data);
        setLoading(false)
    };

    const handleAction = (action) => {
        setAction(action);
    }

    const edit = (category) => {
        setCategory(category)
        handleAction('add')
    }

    const add = () => {

        setCategory(null)
        handleAction('add')
    }

    const handleSuccess = (data) => {
      setTimeout(()=> {
          setAction('list')
          setLoading(true)
          fetchKategorije()
      },1000)
    }

    return (
        <AuthenticatedLayout
            user={user}
            header={
                <div className={'flex justify-between items-center'}>
                    <h2 className="font-semibold text-xl text-white leading-tight">Kategorije</h2>
                    {action==='list' &&
                        <div className="flex gap-2">
                            <SecondaryButton onClick={add}>Dodaj novi kategoriju</SecondaryButton>
                        </div>
                    }
                    {action==='add' &&
                        <SecondaryButton onClick={() => handleAction('list')}>Otkazati</SecondaryButton>
                    }
                </div>
            }
        >
            <div className="mt-4">
                <div className={`max-w-7xl ${action==="list" ? "mx-auto" : ""} sm:px-6 lg:px-8`}>

                        {action==="list" &&
                            <div className="bg-white overflow-hidden shadow-sm sm:rounded-lg p-8">
                            <>
                                {loading ? (
                                    <div className="flex flex-col w-full items-center">
                                        <div className="animate-spin border-2 border-t-2 border-blue-950 w-5 h-5 rounded-full"></div>
                                    </div>
                                ) : (
                                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                                        {kategorije.map((kategorija) => (
                                            <div
                                                key={kategorija.term_id}
                                                onClick={()=> {edit(kategorija)}}
                                                className="border border-blue-950 rounded-lg p-4 text-center hover:bg-blue-50 transition cursor-pointer"
                                            >
                                                <h3 className="text-blue-950 font-semibold text-lg">{kategorija.name}</h3>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </>
                            </div>
                        }
                        {action==='add' &&
                            <AddKategorije kategorija={category} onSuccess={handleSuccess}/>
                        }

                </div>
            </div>
        </AuthenticatedLayout>
    );
}
